import React, { useEffect, useState } from 'react';
import PendingInvoices from '../../Components/TCInvoiceItems/PendingTab/PendingTab';
import HistoryInvoices from '../../Components/TCInvoiceItems/HistoryTab/HistoryTab';
import apiClient from "../../../../../Config/apiClient";
import { showErrorToast } from "../../../../../Context/Toaster/Toaster";
import './TCInvoices.scss';

const InvoicePath = process.env.REACT_APP_HS_TCINVOICES_BASE_PATH

const TCInvoices = () => {
  const [allInvoices, setAllInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

   const fetchInvoices = async () => {
    try {
      setLoading(true);
      const res = await apiClient.get(`${InvoicePath}/list`);
      if (res.data.status === 'SUCCESS') {
        setAllInvoices(res.data.data || []);
      } else {
        showErrorToast("Failed to fetch invoices.");
      }
    } catch (err) {
      showErrorToast("Server error while fetching invoices.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvoices();
  }, []);

  const pendingInvoices = allInvoices.filter(inv => inv.paid_status === 0);
  const historyInvoices = allInvoices;

  return (
    <main className="full-wraper">
      <div className="main-wraper">
        <div className="container-fluid">
          <div className="main-inner">

            <div className="common-top">
              <div className="ct-tabs mt-0">
                <ul className="nav nav-tabs jtabs" id="invoiceTabs" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button className="nav-link ctt-button active" id="pending-tab" data-bs-toggle="tab" data-bs-target="#pending" type="button" role="tab" aria-controls="pending" aria-selected="true">
                      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
                        <g id="carbon_pending_1_" data-name="carbon_pending (1)" transform="translate(-1 -1)">
                          <path id="fill-change" data-name="Path 1234" d="M5,10A1.5,1.5,0,1,0,3.5,8.5,1.5,1.5,0,0,0,5,10Z" transform="translate(1.25 3)" />
                          <path id="fill-change" data-name="Path 1235" d="M12,10a1.5,1.5,0,1,0-1.5-1.5A1.5,1.5,0,0,0,12,10Z" transform="translate(4.75 3)" />
                          <path id="fill-change" data-name="Path 1236" d="M8.5,10A1.5,1.5,0,1,0,7,8.5,1.5,1.5,0,0,0,8.5,10Z" transform="translate(3 3)" />
                          <path id="fill-change" data-name="Path 1237" d="M11.5,22a10.512,10.512,0,1,1,7.421-3.079A10.5,10.5,0,0,1,11.5,22Zm0-19.5a9.01,9.01,0,1,0,6.361,2.639A9,9,0,0,0,11.5,2.5Z" transform="translate(0)" />
                        </g>
                      </svg>
                      <span>Pending</span>
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className="nav-link ctt-button" id="history-tab" data-bs-toggle="tab" data-bs-target="#history" type="button" role="tab" aria-controls="history" aria-selected="false">
                      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
                        <g id="solar_history-broken" transform="translate(-2.25 -2.25)">
                          <path id="stroke-change" data-name="Path 1238" d="M12,8v4.308L14.692,15" transform="translate(0.75 0.442)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                          <path id="fill-change" data-name="Path 1239" d="M4.5,7.226l-.808,0a.808.808,0,0,0,.8.8Zm2.738.821a.808.808,0,1,0,.008-1.615ZM5.292,4.48a.808.808,0,1,0-1.615.009ZM3.865,12.75a.808.808,0,0,0-1.615,0ZM18,21.845a.808.808,0,1,0-.808-1.4Zm2.447-4.652a.808.808,0,1,0,1.4.808ZM5.362,5.287A.808.808,0,0,0,6.5,6.435Zm14.778.072A10.5,10.5,0,0,0,5.291,5.291l1.142,1.14A8.886,8.886,0,0,1,19,6.5ZM5.291,5.291,3.928,6.655,5.069,7.8,6.434,6.434Zm-.8,2.743,2.742.013.008-1.615L4.5,6.419Zm.812-.812L5.292,4.48l-1.615.009L3.691,7.23ZM12.75,3.865a8.885,8.885,0,0,1,8.885,8.885H23.25a10.5,10.5,0,0,0-10.5-10.5Zm0,17.769A8.884,8.884,0,0,1,3.865,12.75H2.25a10.5,10.5,0,0,0,10.5,10.5Zm4.442-1.188a8.83,8.83,0,0,1-4.442,1.188V23.25A10.453,10.453,0,0,0,18,21.845Zm4.442-7.7a8.83,8.83,0,0,1-1.188,4.442l1.4.808a10.447,10.447,0,0,0,1.405-5.25ZM6.5,6.435a8.851,8.851,0,0,1,6.25-2.57V2.25A10.467,10.467,0,0,0,5.362,5.287Z" transform="translate(0 0)" />
                        </g>
                      </svg>
                      <span>History</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            <div className="tab-content" id="invoiceTabContent">
              <div className="tab-pane fade show active" id="pending" role="tabpanel" aria-labelledby="pending-tab">
                <PendingInvoices invoices={pendingInvoices} loading={loading} refreshInvoices={fetchInvoices}/>
              </div>
              <div className="tab-pane fade" id="history" role="tabpanel" aria-labelledby="history-tab">
                <HistoryInvoices invoices={historyInvoices} loading={loading} refreshInvoices={fetchInvoices}/>
              </div>
            </div>

          </div>
        </div>
      </div>
    </main>
  );
};

export default TCInvoices;